"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLoadedSlots = exports.ReservationInformation = void 0;
const moment_1 = __importDefault(require("moment"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const ImmutableDataController_1 = __importDefault(require("orbiter-core/src/datastructures/ImmutableDataController"));
const TimeSlotIDC_1 = __importDefault(require("orbiter-core-planner/lib/TimeSlotIDC"));
const bson_objectid_1 = __importDefault(require("bson-objectid"));
;
;
class ReservationInformation extends ImmutableDataController_1.default {
    constructor(name, telephone, email, isProject, appartmentNumber, projectName, projectCode, version, type, currentAddress, worksiteAddress, vatNumber) {
        super();
        this.name = name;
        this.telephone = telephone;
        this.email = email;
        this.isProject = isProject;
        this.appartmentNumber = appartmentNumber;
        this.projectName = projectName;
        this.projectCode = projectCode;
        this.version = version;
        this.type = type;
        this.currentAddress = currentAddress;
        this.worksiteAddress = worksiteAddress;
        this.vatNumber = vatNumber;
    }
    static create() {
        return new ReservationInformation("", "", "", false, "", "", "", 2, "", "", "", "");
    }
    clone() {
        return new ReservationInformation(this.name, this.telephone, this.email, this.isProject, this.appartmentNumber, this.projectName, this.projectCode, this.version, this.type, this.currentAddress, this.worksiteAddress, this.vatNumber);
    }
}
__decorate([
    ImmutableDataController_1.default.dataProperty()
], ReservationInformation.prototype, "name", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], ReservationInformation.prototype, "telephone", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], ReservationInformation.prototype, "email", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], ReservationInformation.prototype, "isProject", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "appartmentNumber", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "projectName", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "projectCode", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null || x === undefined) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "version", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null || x === undefined) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "type", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null || x === undefined) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "currentAddress", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null || x === undefined) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "worksiteAddress", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty((x) => { if (x === null || x === undefined) {
        return null;
    }
    else {
        return x;
    } ; })
], ReservationInformation.prototype, "vatNumber", void 0);
exports.ReservationInformation = ReservationInformation;
function parseLoadedSlots(slots) {
    const bringToWallTime = (dateString) => {
        // Because we want to display our dates and times in Europe/Brussels at all times, we convert the incoming dates in UTC to Europe/Brussels and pass the results of this operation again to moment which interpretes it as if it were local time.
        // This results in dates and times being displayed in Europe/Brussels time.
        const format = "YYYY-MM-DD HH:mm";
        const wallTimeString = moment_timezone_1.default.tz(dateString, "Europe/Brussels").utc(true).format(format);
        return moment_1.default(wallTimeString, format);
    };
    const res = slots.map((s) => {
        return {
            day: bringToWallTime(s.day),
            slots: s.slots.map((ss) => {
                return new TimeSlotIDC_1.default(new bson_objectid_1.default(ss.id), bringToWallTime(ss.start).toDate(), bringToWallTime(ss.end).toDate(), ss.bookings, ss.maxBookings);
            })
        };
    });
    return res;
}
exports.parseLoadedSlots = parseLoadedSlots;
//# sourceMappingURL=data.js.map